<div [class.loader-hidden]="!show">
    <div class="loading">
            <!--<div>
                <md-progress-bar mode="indeterminate" *ngIf="show"></md-progress-bar>
            </div>-->
    </div>
</div>